import React from 'react';

import type { CentraProductsContext, ProductItemParams } from './types';

const initialState = {};
const CentraCategoryPageContext = React.createContext<CentraProductsContext & ProductItemParams>(initialState);

export default CentraCategoryPageContext;
